import React, { useEffect, useMemo, useState } from "react";
import "../modules/Footer.css";
import { useT, useI18nReady } from "../components/TextProvider";

export default function PromptFooter({
  onLanguageChange, // (lang) => void
  socials = {
    telegram: "#",
    github: "#",
    youtube: "#",
    linkedin: "#",
    x: "#",
  },
  nav, // можем принять снаружи, но дефолт сделаем внутри
}) {
  // ХУКИ — строго в начале компонента
  const t = useT();
  const ready = useI18nReady();

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // "ok" | "err" | null
  const [theme, setTheme] = useState(() => localStorage.getItem("pc-theme") || "auto");
  const [lang, setLang] = useState("ru");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "auto") {
      root.removeAttribute("data-theme");
    } else {
      root.setAttribute("data-theme", theme);
    }
    localStorage.setItem("pc-theme", theme);
  }, [theme]);

  const year = useMemo(() => new Date().getFullYear(), []);

  // если переводы ещё не готовы — ничего не рендерим
  if (!ready) return null;

  const brand = t("logoFooter");
  const tagline = t("logoSub");

  // Дефолтная навигация — уже с t(...)
  const defaultNav = {
    Manzil: [
      { label: t("adres"), href: t('addressShort') },
    ],
    Telefon: [
      { label: t('telShort'), href: t("tel") },
    ],
    Pochta: [
      { label: t('mailShort'), href: t('mail') },
    ],
  };

  const navToRender = nav || defaultNav;

  function handleSubmit(e) {
    e.preventDefault();
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!ok) {
      setStatus("err");
      return;
    }
    // TODO: интеграция с бэкендом
    setStatus("ok");
    setEmail("");
  }

  function handleLangChange(e) {
    const value = e.target.value;
    setLang(value);
    onLanguageChange && onLanguageChange(value);
  }

  return (
    <footer className="pc-footer" aria-label="Футер сайта о правильных запросах к ИИ">
      <div className="pc-footer__accent" aria-hidden="true" />

      <div className="pc-footer__inner">
        {/* Бренд и описательная часть */}
        <div className="pc-footer__brand">
          <div className="pc-footer__logo" aria-label={brand}>
            <svg viewBox="0 0 32 32" className="pc-footer__logoMark" role="img" aria-label="Логотип">
              <defs>
                <linearGradient id="pc-g" x1="0" x2="1" y1="1" y2="0">
                  <stop offset="0%" stopColor="var(--accent-1)" />
                  <stop offset="100%" stopColor="var(--accent-2)" />
                </linearGradient>
              </defs>
              <rect x="2" y="2" width="28" height="28" rx="8" fill="url(#pc-g)" />
              <path
                d="M8 20c6-1 8-5 8-8v8c0 3 2 5 8 6"
                fill="none"
                stroke="var(--bg-elev)"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <span className="pc-footer__logoText">{brand}</span>
          </div>

          <p className="pc-footer__tagline">{tagline}</p>
        </div>

        {/* Навигация */}
        <nav className="pc-footer__nav" aria-label="Навигация по разделам">
          {Object.entries(navToRender).map(([group, items]) => (
            <div className="pc-navCol" key={group}>
              <h3 className="pc-navCol__title">{group}</h3>
              <ul className="pc-navCol__list">
                {items.map(({ label, href }) => (
                  <li key={label}>
                    <a className="pc-link" href={href}>{label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      {/* Нижняя плашка */}
      <div className="pc-footer__bottom">
        <div className="pc-bottom__left">
          <span>© {year} {t("logoFooter")}</span>
          <span className="pc-dot" aria-hidden>•</span>
          <a className="pc-link" href="#">Shartlar</a>
          <span className="pc-dot" aria-hidden>•</span>
          <a className="pc-link" href="#">Maxfiylik</a>
        </div>

        
      </div>
    </footer>
  );
}
